import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';
import PropTypes from 'prop-types';

const PrivateRoute = ({ children }) => {
  const [checking, setChecking] = useState(true);
  const [isAllowed, setIsAllowed] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (isMounted) {
        // 匿名ログインは禁止、本登録ユーザーのみ許可
        setIsAllowed(!!user && !user.isAnonymous);
        setChecking(false);
      }
    });
    return () => {
      isMounted = false;
      unsubscribe();
    };
  }, []);

  if (checking) {
    return (
      <div style={{
        padding: '40px',
        textAlign: 'center',
        color: '#999',
        fontSize: '18px',
        fontFamily: 'sans-serif',
      }}>
        🔐 認証を確認中です...
      </div>
    );
  }

  return isAllowed ? children : <Navigate to="/login" />;
};

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PrivateRoute;
